var map = {
	"./0.png": 190,
	"./1.png": 855,
	"./2.png": 364,
	"./3.png": 397,
	"./4.png": 146,
	"./T0.png": 8,
	"./T1.png": 137,
	"./T2.png": 554,
	"./T3.png": 763,
	"./T4.png": 540
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7;